import React from 'react';
import BannerSection from "./BannerSection";
import ActionSection from "./ActionSection";
import CatchphraseSection from "./CatchphraseSection";
import FeatureSection from "./FeatureSection";

const Home = () => (
    <>
        <BannerSection />
        <CatchphraseSection />
        <FeatureSection />
        <ActionSection />
    </>
);

export default Home;